import * as React from "react";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";

import SectionCaption from "../../../../components/UI/SectionCaption";

const styles = (theme) => ({
  feedCard: {
    marginBottom: 20,
  },
  thumbnail: {
    height: 240,
    textAlign: "center",
    marginBottom: 20,
    "& img": {
      height: "100%",
    },
  },
  bold: {
    fontWeight: 500,
  },
  paragraph: {
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: 10,
      textAlign: "justify",
    },
    "& p": {
      display: "none",
    },
    "& p:first-of-type": {
      display: "block",
    },
    "& img": {
      display: "none",
    },
  },
});

const FeedCard = (props) => {
  const { classes, feedData } = props;
  return (
    <Grid item xs={6} className={classes.feedCard}>
      {
        feedData.thumbnail && <div className={classes.thumbnail}>
          <img src={feedData.thumbnail} alt={feedData.title} />
        </div>
      }
      <SectionCaption className={classes.bold}>{feedData.title}</SectionCaption>
      <div
        className={classes.paragraph}
        dangerouslySetInnerHTML={{ __html: feedData.description }}
      />
      <a href={feedData.link} target={"_blank"}>
        <Button
          color="primary"
          size="small"
          variant="outlined"
          style={{ float: "right" }}
        >
          Read More
        </Button>
      </a>
    </Grid>
  );
};

FeedCard.propTypes = {
  classes: PropTypes.object.isRequired,
  feedData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    author: PropTypes.string,
    thumbnail: PropTypes.string,
    description: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(FeedCard);



// WEBPACK FOOTER //
// ./src/containers/Feed/components/FeedCard/index.jsx